// extracted by mini-css-extract-plugin
export default {"separator":"separator__Q2bVMSN6","loginCard":"loginCard__pz4qxIO0","registerText":"registerText__y1aNO6mO","infoBanner":"infoBanner__IuxZ8nIG"};